// ビュー登録（外枠→中身統合）。id → render(el, ctx)。
// 帳票・収支・マスタは既存プロトタイプを埋め込み（順次 Firestore バインドへ）。取込は実データ実装。
import { makePlaceholder } from './placeholder.js'
import { renderDashboard } from './dashboard.js' // 中身/TMS: 経営ダッシュボード（trips×tachographs 集約）
import { renderIngest } from './ingest.js' // 中身/TMS: データ取込（CSV → trips / tachographs）
import { renderChargesheet } from './chargesheet.js' // 中身/TMS: 運賃お伺い書（trips連動・発行履歴）
import { renderOperations } from './operations.js' // 中身/TMS: 運行実績×収支（trips×tachographs 突合・客先別収支）
import { renderBilling } from './billing.js' // 中身/TMS: 請求・支払（締め集計・得意先/協力会社別）
import { renderInvoice } from './invoice.js' // 中身/TMS: 得意先向け請求書（実物様式・A4横・@media print）
import { makeEmbed } from './embed.js'
import { renderDispatch } from './dispatch.js' // 中身/TMS: 配車・受注（ハコベル orders 一覧）
import { renderIntake } from './intake.js' // 中身/TMS: 依頼主受付（SS一覧＋ハコベル風詳細）
import { renderTeiki } from './teiki.js' // 中身/TMS: 定期便マスタ＋当日生成
import { renderVehicles } from './vehicles.js' // 中身/TMS: 車両台帳（実データ化・車種/日額編集→車両経費連動）
import { renderDrivers } from './drivers.js' // 中身/TMS: 乗務員マスタ（実データ化・給与区分/固定給編集）
import { renderDataExport } from './dataexport.js' // 中身/TMS: データ出力（各集計＋元データをCSV/Excelで書き出し）
import { renderPayroll } from './payroll.js' // 中身/TMS: 給与（月次の支給予定額一覧・歩合は収支の人件費と±0）

export const views = {
  dashboard: renderDashboard, // 全社KPI・売上/コスト構成・全社P&L・乗務員収支（実データ）
  ingest: renderIngest,
  dataexport: renderDataExport, // 中身/TMS: 運行実績×収支の各集計・元データをCSV(UTF-8 BOM/Excel対応)で出力
  dispatch: renderDispatch, // 中身/TMS: 受注一覧（ハコベル orders・月次）
  intake: renderIntake, // 中身/TMS: 依頼主受付（仮/正式・メール証跡）
  teiki: renderTeiki, // 中身/TMS: 定期便マスタ＋当日ワンクリック生成
  operations: renderOperations, // trips×tachographs を乗務員コード×期間で突合 → 客先別 実コスト収支
  billing: renderBilling, // 得意先別請求／協力会社別支払 の締め集計・傭車取り分（trips連動）
  invoice: renderInvoice, // NAV に出さない帳票ルート（#/invoice?m=&k=）。請求・支払の得意先行から開く
  chargesheet: renderChargesheet, // trips → 相手先×月×区分 の実データ集計＋発行履歴（Supabase連動）
  platform: makeEmbed('プラットフォーム請求', 'platform', 'ハコベル等の案件完了ベース請求サマリー（日次取込と突合）。'),
  vehicles: renderVehicles, // 実データ台帳：車種・日額を編集→車両経費（運行実績×収支）へ即反映
  drivers: renderDrivers, // 実データ名簿：給与区分（歩合/固定給）・固定給月額を編集

  customers: makeEmbed('得意先・単価', 'customers', '得意先マスタ・運賃タリフ（ブロック別）。'),
  tachograph: makePlaceholder('デジタコ（富士通 ITP-WebMP）連携', 'デジタコCSVの取込は「データ取込」から実行（tachographs へ蓄積）。ここは連携方式・確定反映の設定画面。', [
    '取込方式・頻度（PAD → Drive → 取込）', '突合キー（乗務員コード × 運行期間）', '実車率・実燃料の確定反映',
  ]),
  payroll: renderPayroll, // 月次の支給予定額（歩合＝運賃×歩合率で収支の人件費と±0／月給＝マスタ月額）
}
